import {isPermissionActive, type Permission} from '../../../pages/permissions/permissionMetadata'

export function permissionIds(value: unknown): string[] {
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value)
    } catch {
      return []
    }
  }
  return Array.isArray(value) ? value.map(String) : []
}

export function permissionsFromGroups(catalog: Permission[], groups: any[], userGroups: unknown) {
  const assignedGroups = new Set(permissionIds(userGroups))
  const assignedFeatures = new Set(
    groups
      .filter((group) => assignedGroups.has(String(group.id_feature_group)))
      .flatMap((group) => permissionIds(group.data))
  )
  return catalog.filter(
    (feature) => isPermissionActive(feature) && assignedFeatures.has(String(feature.id_feature))
  )
}
